import { SHOP } from '@/lib/data/shop';

const query = encodeURIComponent(`${SHOP.name}, ${SHOP.street}, ${SHOP.town} ${SHOP.postcode}`);

/**
 * Brand marks for Google Maps and Apple Maps, taken from the Simple Icons set
 * (CC0 icon set; the marks themselves remain trademarks of their owners). Used
 * nominatively, to identify the service each link opens.
 *
 * Rendered in currentColor rather than brand colours, so they stay inside the
 * site's palette.
 */

function GoogleMapsMark() {
  return (
    <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" fill="currentColor">
      <path d="M19.527 4.799c1.212 2.608.937 5.678-.405 8.173-1.101 2.047-2.744 3.74-4.098 5.614-.619.858-1.244 1.75-1.669 2.727-.141.325-.263.658-.383.992-.121.333-.224.673-.34 1.008-.109.314-.236.684-.627.687h-.007c-.466-.001-.579-.53-.695-.887-.284-.874-.581-1.713-1.019-2.525-.51-.944-1.145-1.817-1.79-2.671L19.527 4.799zM8.545 7.705l-3.959 4.707c.724 1.54 1.821 2.863 2.871 4.18.247.31.494.622.737.936l4.984-5.925-.029.01c-1.741.601-3.691-.291-4.392-1.987a3.377 3.377 0 0 1-.209-.716c-.063-.437-.077-.761-.004-1.198l.001-.007zM5.492 3.149l-.003.004c-1.947 2.466-2.281 5.88-1.117 8.77l4.785-5.689-.058-.05-3.607-3.035zM14.661.436l-3.838 4.563a.295.295 0 0 1 .027-.01c1.6-.551 3.403.15 4.22 1.626.176.319.323.683.377 1.045.068.446.085.773.012 1.22l-.003.016 3.836-4.561A8.382 8.382 0 0 0 14.67.439l-.009-.003zM9.466 5.868L14.162.285l-.047-.012A8.31 8.31 0 0 0 11.986 0a8.439 8.439 0 0 0-6.169 2.766l-.016.018 3.665 3.084z" />
    </svg>
  );
}

function AppleMark() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="currentColor">
      <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
    </svg>
  );
}

/**
 * Small text links rather than buttons. Both work with no JavaScript and with
 * no tiles loaded, which is what most people tap anyway.
 */
export function MapLinks() {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${SHOP.lat},${SHOP.lng}`}
        target="_blank"
        rel="noopener noreferrer"
        className="label-xs flex items-center gap-2 text-ink transition-colors hover:text-brick"
      >
        <GoogleMapsMark />
        Google Maps
      </a>

      <span aria-hidden="true" className="h-3.5 w-px bg-ink/25" />

      <a
        href={`https://maps.apple.com/?q=${query}&ll=${SHOP.lat},${SHOP.lng}`}
        target="_blank"
        rel="noopener noreferrer"
        className="label-xs flex items-center gap-2 text-ink transition-colors hover:text-brick"
      >
        <AppleMark />
        Apple Maps
      </a>
    </div>
  );
}
